import CadastrarNome from "../../componentes/form/cadastrar-nome";

export default function NovaNaturezaDespesa() {

  return <CadastrarNome label="Natureza Despesa" labelListagem='Listagem Natureza' url='/naturezaDespesa' urlAlterar="/alterarNatureza"/>
}